//@flow
import * as actionTypes from '../../../redux/gorgon/actionTypes';
import collect from 'collect.js'
import { YES, NO } from './variables'
import type { DocDataExtractionForm$PropsType } from '../flowTypes'
import type { Collection } from 'collect.js'

const validate = (values:any,props:DocDataExtractionForm$PropsType) => {
    const errors = {};
    let requiredFields = [
        'formNum',
        'memEmpCheckWhoIsApply',
        'memEmpFirstName',
        'memEmpLastName',
        'appFirstName',
        'appLastName',
        'appStreetAddrLine1',
        'appCity',
        'appState',
        'appZip',
        'appSex',
        'appWorkPhoneNum',
        'appHomePhoneNum',
        'applicantSignatureDate'
    ];
    if (values.isOverrideMemEmpCheckWhoIsApply){
        requiredFields=requiredFields.filter(item=> item!=='memEmpCheckWhoIsApply')
    }
    if (values.isOverrideMemEmpFirstNameNotFound){
        requiredFields=requiredFields.filter(item=> item!=='memEmpFirstName')
    }
    if (values.isOverrideMemEmpLastNameNotFound){
        requiredFields=requiredFields.filter(item=> item!=='memEmpLastName')
    }
    if (values.isOverrideAppFirstNameNotFound){
        requiredFields=requiredFields.filter(item=> item!=='appFirstName')
    }
    if (values.isOverrideAppLastNameNotFound){
        requiredFields=requiredFields.filter(item=> item!=='appLastName')
    }
    if (values.isOverrideAppStreetAddrLine1NotFound){
        requiredFields=requiredFields.filter(item=> item!=='appStreetAddrLine1')
    }
    if (values.isOverrideAppCityNotFound){
        requiredFields=requiredFields.filter(item=> item!=='appCity')
    }
    if (values.isOverrideAppStateNotFound){
        requiredFields=requiredFields.filter(item=> item!=='appState')
    }
    if (values.isOverrideAppZipNotFound){
        requiredFields=requiredFields.filter(item=> item!=='appZip')
    }
    if (values.isOverrideAppSexNotFound){
        requiredFields=requiredFields.filter(item=> item!=='appSex')
    }
    if (values.isOverrideAppWorkPhoneNumNotFound){
        requiredFields=requiredFields.filter(item=> item!=='appWorkPhoneNum')
    }
    if (values.isOverrideAppHomePhoneNumNotFound){
        requiredFields=requiredFields.filter(item=> item!=='appHomePhoneNum')
    }
    if (values.isOverrideApplicantSignatureDateNotFound){
        requiredFields=requiredFields.filter(item=> item!=='applicantSignatureDate')
    }
    if (values && !values.isDocNotLoad && !values.isDocInvalid && !values.isOverrideFormNum && !values.isNoFormNumInDoc  ){
        requiredFields.forEach(field => {
            if (!values[field]) {
                errors[field] = 'This field is required'
            }
        })
    }else {
        if (values.isOverrideFormNum && !values.formNum){
            errors['formNum'] = 'This field is required'
        }
    }
    
    if (values.heightFeet && parseInt(values.heightFeet)>12){
        errors['heightFeet'] = 'Maximum Feet is 12!'
    }
    if (values.heightInches && parseInt(values.heightInches)>120){
        errors['heightInches'] = 'Maximum Inches is 120!'
    }
    if (!values.heightFeet && values.heightInches && values.heightInches > 12 ){
        const remainder = parseInt(values.heightInches) % 12
        const feet = (parseInt(values.heightInches) - remainder) / 12 
        const changeFieldValue = (props.changeFieldValue:any)
        changeFieldValue('heightFeet',feet)
        changeFieldValue('heightInches',remainder)
    }
    
    validateQualityReviewQuestions(values,errors,props)

    const updateFormError = (props.updateFormError:any)
    updateFormError(errors);

    return errors;
}

const validateQualityReviewQuestions=(values:any,errors:any,props:DocDataExtractionForm$PropsType)=>{
    const gorgon = (props.gorgon:any)
    const reviewQuestions = (gorgon.reviewQuestions:any)

    const questions = reviewQuestions.filter(question=> question.mandatory == true)
    questions.map(question=>{
        if (question.questionType == 'singleSelect'){
            if (!values[question.elementId]){
                errors[question.elementId] = 'This field is required!'
            }
        }else if (question.questionType == 'yesNo'){
            const yesElement = `${question.elementId}_${YES}`
            const noElement = `${question.elementId}_${NO}`

            if (!values[yesElement] && !values[noElement]){
                errors[yesElement] = 'Please select at least one answer.'
                errors[noElement] = 'Please select at least one answer.'
            }else {
                if (values[yesElement]){
                    let anySubAnswers = []
                    question.yesSubAnswers.map(subAnswer=>{
                        if (values[subAnswer.field]){
                            anySubAnswers.push(subAnswer)
                        }
                    })
                    if (anySubAnswers.length == 0){
                        question.yesSubAnswers.map(subAnswer=>{
                            if (!values[subAnswer.field]){
                                errors[subAnswer.field] = 'Please select at least one answer.'
                            }
                        })
                    }
                }
            }
        }
    })
}

const getQualityReviewFormNoOfError=(props:DocDataExtractionForm$PropsType,collectErrorFields:Collection<any>)=>{
    let noOfError = 0
    const gorgon = (props.gorgon:any)
    const reviewQuestions = (gorgon.reviewQuestions:any)

    const questions = reviewQuestions.filter(question=> question.mandatory == true)
    questions.map(question=>{
        if (question.questionType == 'singleSelect'){
            if (collectErrorFields.has(question.elementId)){
                noOfError+=1
            }
        }else if (question.questionType == 'yesNo'){
            const yesElement = `${question.elementId}_${YES}`
            const noElement = `${question.elementId}_${NO}`

            if (collectErrorFields.has(yesElement) && collectErrorFields.has(noElement)){
                noOfError+=1
            }else {
                let anySubAnswersError = false
                question.yesSubAnswers.map(subAnswer=>{
                    if (collectErrorFields.has(subAnswer.field)){
                        anySubAnswersError = true
                    }
                })
                if (anySubAnswersError){
                    noOfError+=1
                }    
            }
        }
    })

    return noOfError
}

const empMemInfoFields = [
    'memEmpCheckWhoIsApply',
    'memEmpFirstName',
    'memEmpLastName'
]

const applicantInfoFields = [
    'appFirstName',
    'appLastName',
    'appStreetAddrLine1',
    'appCity',
    'appState',
    'appZip',
    'appSex',
    'appWorkPhoneNum',
    'appHomePhoneNum'
]

const isAnyFormErrors=(formError:any,panel:any,props:DocDataExtractionForm$PropsType)=>{
    let noOfErrors = 0
    const collectErrorFields =  collect(formError) 
    switch(panel){
        case actionTypes.GORGON_PANEL_EMP_MEM_INFO:
            empMemInfoFields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors = parseInt(noOfErrors) + 1
                }
            })
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }
                
            return null
            
        case actionTypes.GORGON_PANEL_APPLICANT_INFO:   
            applicantInfoFields.forEach(field=> {
                if (collectErrorFields.has(field)){
                    noOfErrors=parseInt(noOfErrors) + 1
                }
            })
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }

            return null
        
        case actionTypes.GORGON_PANEL_ADDITIONAL_QUESTIONS:
            if (collectErrorFields.has('applicantSignatureDate')){
                noOfErrors=parseInt(noOfErrors) + 1
            }
                
            if (parseInt(noOfErrors) > 0){
                return noOfErrors
            }

            return null
        
        case actionTypes.GORGON_PANEL_REVIEW_QUESTIONS:
            noOfErrors = getQualityReviewFormNoOfError(props,collectErrorFields)

            if (noOfErrors){
                return noOfErrors
            }else {
                return null
            }

        default:
            return null
    }
    //return null
}

exports.validate=validate
exports.isAnyFormErrors=isAnyFormErrors


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/common/validate.js